import React from 'react'
import { Mutation } from "react-apollo";
import LayoutTypesForm from "../components/form";
import { ADD_LAYOUT_TYPE, GET_LAYOUT_TYPE } from "../../../queries/layout_type";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD_LAYOUT_TYPE}
      update={(store, { data: { createLayoutType } }) => {
        const { layoutType } = store.readQuery({ query: GET_LAYOUT_TYPE });
        store.writeQuery({
          query: GET_LAYOUT_TYPE,
          data: { layoutType: layoutType.concat([createLayoutType]) }
        });
      }}
      >
        
      {createLayoutType => (
        <LayoutTypesForm query_f = {createLayoutType} {...props}/>
      )}
    </Mutation>
  );
};

export default Add;